import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState: DetailState<IInventoryType> = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  details: null,
};

export const inventoryTypeSlice = createSlice({
  name: "inventoryType",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceInventoryType: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addInventoryType: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateInventoryType: (state, action) => {
    const { data } = action.payload;
    if (state.data) {
    const index = state.data.findIndex(item => item.id === data.id);
    if (index !== -1) {
      state.data[index] = data;
    }
    }
    state.details = data;
    },

    deleteInventoryType: (state, action) => {
      const inventoryTypeToRemove: IInventoryType = action.payload.data;
      const newInventoryTypeData =
        state.data &&
        state.data.filter((inventoryType: IInventoryType) => {
          return inventoryType.id !== inventoryTypeToRemove.id;
        });
      state.data = newInventoryTypeData;
      state.totalCount = state.totalCount - 1;
    },
    setInventoryTypeDetails: (state, action) => {
      state.details = action.payload.data;
    },
  },
});

export const inventoryTypeActions = inventoryTypeSlice.actions;

export default inventoryTypeSlice.reducer;
